

























































































import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';

  @Component
export default class PartView extends Vue {
    @Prop()
    private parts: any;

    @Prop({ default: 0 })
    private selectedPart = 0;

    private localSelectedPart = 0;

    private dialog = false;

    private headers = [
      {
        text: '隊列名',
        sortable: false,
        value: 'name',
      },
      { text: '削除', value: 'actions', sortable: false },
    ];

    mounted() {
      this.localSelectedPart = this.selectedPart;
      this.$nextTick();
    }

    @Watch('localSelectedPart')
    onTextChanged(newText: number, oldText: string) {
      this.$emit('update', this.localSelectedPart);
    }

    registerItem() {
      let num;
      if (this.parts.length > 0) {
        num = this.parts.map((a: any) => a.order)
          .reduce((a: any, b: any) => (a > b ? a : b));
        num += 1;
      } else {
        num = 0;
      }

      const part = {
        order: num,
        name: '',
      };

      this.parts.push(part);
    }

    update() {
      this.dialog = false;
      localStorage.setItem('parts', JSON.stringify(this.parts));
      this.$emit('updatePart');
    }

    deleteItem(item: any) {
      const index = this.parts.indexOf(item);
      this.parts.splice(index, 1);
    }
}
